import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.url.to-json.js";
// Copyright 2017-2022 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { assert, stringCamelCase } from '@polkadot/util';

function isTx(tx, callIndex) {
  return tx.callIndex[0] === callIndex[0] && tx.callIndex[1] === callIndex[1];
}
/** @internal */


export function createUnchecked(registry, section, callIndex, callMetadata) {
  var expectedArgs = callMetadata.fields;
  var funcName = stringCamelCase(callMetadata.name);

  var extrinsicFn = function extrinsicFn() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    assert(expectedArgs.length === args.length, function () {
      return "Extrinsic ".concat(section, ".").concat(funcName, " expects ").concat(expectedArgs.length, " arguments, got ").concat(args.length, ".");
    });
    return registry.createTypeUnsafe('Call', [{
      args: args,
      callIndex: callIndex
    }, callMetadata]);
  };

  extrinsicFn.is = function (tx) {
    return isTx(tx, callIndex);
  };

  extrinsicFn.callIndex = callIndex;
  extrinsicFn.meta = callMetadata;
  extrinsicFn.method = funcName;
  extrinsicFn.section = section;

  extrinsicFn.toJSON = function () {
    return callMetadata.toJSON();
  };

  return extrinsicFn;
}